<template>
    <div class="photo-lower-bar-button-group">
        <div class="photo-lower-bar-button-custom" v-on:click="rotateRight()">
            <SVGPhotoRotateLeft45 class="lb-svg-rotate"/>
        </div>
        <div class="photo-lower-bar-button-custom no-left-padding" v-on:click="rotateLeft()">
            <SVGPhotoRotateRight45 class="lb-svg-rotate"/>
        </div>
        <div class="photo-lower-bar-button no-left-padding">
            <div class="photo-lower-bar-button-text" style="cursor: default; color: #939393;">Повернуть</div>
        </div>
        <div class="photo-lower-bar-button" v-on:click="switchShades()">
            <SVGShadeOff v-show="!shadowStatus" class="lb-svg"/>
            <SVGShadeOn v-show="shadowStatus" class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">{{shadeButtonText}}</span>
        </div>
        <div class="photo-lower-bar-button" v-on:click="switchLightCorrection()">
            <SVGSunBlack v-show="lightCorrectionStatus" class="lb-svg"/>
            <SVGSunShine v-show="!lightCorrectionStatus" class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">{{lightCorrectionButtonText}}</span>
        </div>
    </div>
</template>

<script>
    import SVGPhotoRotateLeft45 from "../../SVG/SVGPhotoRotateLeft45";
    import SVGPhotoRotateRight45 from "../../SVG/SVGPhotoRotateRight45";
    import SVGShadeOff from "../../SVG/SVGShadeOff";
    import SVGShadeOn from "../../SVG/SVGShadeOn";
    import SVGSunBlack from "../../SVG/SVGSunBlack";
    import SVGSunShine from "../../SVG/SVGSunShine";

    export default {
        name: "LeftLowerBarDesignPlaneOptions",
        components: {
            SVGSunShine,
            SVGSunBlack,
            SVGShadeOn,
            SVGShadeOff,
            SVGPhotoRotateRight45,
            SVGPhotoRotateLeft45,
        },
        computed: {
            shadowStatus() {
                return this.$store.getters["active/SHADOW_STATUS"]
            },
            lightCorrectionStatus() {
                return this.$store.getters["active/LIGHT_CORRECTION_STATUS"]
            },
            shadeButtonText() {
                if (!this.shadowStatus) {
                    return 'Выкл. тени'
                } else {
                    return 'Вкл. тени'
                }
            },
            lightCorrectionButtonText() {
                if (!this.lightCorrectionStatus) {
                    return 'Выкл. коррекцию освещения'
                } else {
                    return 'Вкл. коррекцию освещения'
                }
            },
            planeType() {
                return this.$store.state.route.params.facadeElement
            }
        },
        methods: {
            rotateLeft() {
                this.$store.dispatch('active/ROTATE_LEFT', this.planeType)
            },
            rotateRight() {
                this.$store.dispatch('active/ROTATE_RIGHT', this.planeType)
            },
            switchShades() {
                this.$store.dispatch('active/SWITCH_SHADOWS', !this.shadowStatus)
            },
            switchLightCorrection() {
                this.$store.dispatch('active/SWITCH_LIGHT_CORRECTION', !this.lightCorrectionStatus)
            }
        }
    }
</script>

<style scoped>
    .photo-lower-bar-button-custom {
        display: inline-block;
        color: #939393;
        cursor: pointer;
        user-select: none;
    }

    .light-icon {
        height: 23px;
        width: auto;
    }

    .photo-lower-bar-button-custom:hover {
        color: #808080;
    }

    .photo-lower-bar-button-custom:active {
        color: #707070;
    }
</style>
